<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<el-tabs v-model="activeName" @tab-click="handleClick">
					    <el-tab-pane label="下级汇报" name="1" v-if="$store.state.user.userinfo.flag!=3">
							<div class="selectbar">
								<div>
									<el-input
										size="small"
									 	style="width: 200px !important;" 
										placeholder="搜索汇报" v-model="getdata.title"
										@input="getdata.page = 1;totalPage = 0;dataList();">
									</el-input>
									<el-select
									 	style="margin-left: 10px;width: 120px !important;" 
										v-model="getdata.status" placeholder="请选择状态"
										clearable
										size="small"
										@change="getdata.page = 1;totalPage = 0;dataList();">
										<el-option
											label="已查看"
											value="1">
										</el-option>
										<el-option
											label="未查看"
											value="2">
										</el-option>
									</el-select>
								</div>
								<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							</div>
							<div class="selectdata">
								<myTables 
									:tableData="tableData"
									delkey="id"
									@selectList="selectList"
									:tableHeader="tableHeader"
									:loading="true" 
									:indexs="true"
									:selection="true"></myTables>
								<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
							</div>
						</el-tab-pane>
					    <el-tab-pane label="我的工作汇报" name="2"  v-if="$store.state.user.userinfo.flag!=1">
							<div class="selectbar">
								<div>
									<el-input
										size="small"
										style="width: 200px !important;" 
										placeholder="搜索汇报" v-model="getdata1.title"
										@input="getdata1.page = 1;totalPage = 0;dataList1();">
									</el-input>
									<el-select
										size="small"
										style="margin-left: 10px;width: 120px !important;" 
										v-model="getdata1.status" placeholder="请选择状态"
										clearable
										@change="getdata1.page = 1;totalPage1 = 0;dataList1();">
										<el-option
											label="已查看"
											value="1">
										</el-option>
										<el-option
											label="未查看"
											value="2">
										</el-option>
									</el-select>
								</div>
								<div>
									<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
									<el-button size="small" type="primary" @click="$router.push('/add_hb')">工作汇报</el-button>
								</div>
							</div>
							<div class="selectdata">
								<myTables 
									:tableData="tableData1"
									delkey="id"
									@selectList="selectList"
									:tableHeader="tableHeader"
									:loading="true" 
									:indexs="true"
									:selection="true"></myTables>
								<Page :totalPage="totalPage1" :pageSize="10" @changedata="changedata1"></Page>
							</div>
						</el-tab-pane>
					  </el-tabs>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { rcbg } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import DelData from '@/components/delToast.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default {
		data() {
			return {
				activeName:"",
				getdata:{
					user_id: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					type: 2,//1通知  2汇报
					title: "",
					status: "", // 未查看 2  已查看 1
					page: 1,
				},
				delList:[],
				tableHeader: [],
				getdata1:{
					user_id: this.$store.state.user.userinfo.id,
					flag: this.$store.state.user.userinfo.flag,
					type: 2,//1通知  2汇报
					title: "",
					status: "", // 未查看 2  已查看 1
					page: 1
				},
				tableData:[],
				totalPage:0,
				tableData1:[],
				totalPage1:0,
			}
		},
		components:{Page,DelData,myTables},
		created() {
			that = this;
			if(that.$store.state.user.userinfo.flag == 3) {
				that.tableHeader = [     // 表头
					{prop: 'title', label: '标题'},
					{prop: 'pub_user', label: '发布人',width:"150"},
					{prop: 'huibao', label: '状态',formatData: function (val) {},width:"100",align:'center'},
					{
						prop: 'addtime', label: '时间',width:'120', formatData: function (val) {
							return that.$changeTime(val)
						}
					},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.godetail},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
						]
					}
				]
			}else {
				that.tableHeader = [     // 表头
					{prop: 'title', label: '标题'},
					{prop: 'pub_user', label: '发布人',width:"150"},
					{
						prop: 'addtime', label: '时间',width:'120', formatData: function (val) {
							return that.$changeTime(val)
						}
					},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '114',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.godetail},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
						]
					}
				]

			}
		},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
			},
			// 下级汇报
			dataList(){
				var that = this;
				rcbg.suboNotice(that.getdata).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			// 我的汇报
			dataList1(){
				var that = this;
				rcbg.myNotice(that.getdata1).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData1 = res.data.pagedata;
						that.totalPage1 = res.data.count;
					}else{
						that.tableData1 = [];
						that.totalPage1 = 0;
					}
				})
			},
			// 切换设置
			handleClick(tab, event) {
				var that = this;
				if(tab.name == 1){
					that.dataList();
				}else{
					that.dataList1();
				}
			},
			// 分页查询
			changedata(current){
				var that = this;
				that.getdata.page = current;
				that.dataList();
			},
			// 分页查询
			changedata1(current){
				var that = this;
				that.getdata1.page = current;
				that.dataList1();
			},
			// 一键删除
			selectList(value){
				that.delList = value;
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						rcbg.delNotice({
							id:that.delList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 详情
			godetail(data){
				var that = this;
				that.$router.push({
					path:'/gzhb_detail',
					query:{
						id:data.tid,
						zbid:data.zbid,
						flag:data.flag,
					}
				})
			},
			// 导出表格
			daochu(){
				var that = this;
				dwgl.exportPartyOrgan(that.getdata);
			}
		},
		mounted() {
			var that = this;
			if(that.$store.state.user.userinfo.flag != 3){
				that.dataList();
				that.activeName = '1'
			}else{
				that.dataList1();
				that.activeName = '2'
			}
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.switchBar{
			width: 100%;
			height: 40px;
			line-height: 40px;
			margin-bottom: 20px;
			border-bottom: 1px solid #DDDDDD;
			span{
				cursor: pointer;
				display: inline-block;
				line-height: 40px;
				font-size: 16px;
				margin-right: 20px;
				padding: 0 20px;
				font-weight: bold;
			}
			span:hover{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
			.selectSwitch{
				color: #BB0000;
				border-bottom: 2px solid #bb0000;
			}
		}
	}
</style>

